import { Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import { Container } from 'reactstrap';
import React, { Component } from 'react';
import GoogleDrive from './GoogleDrive';
import Teams from './Teams';
import SharedDrive from './SharedDrive';
import ScheduleMeeting from './Zoom/ScheduleMeeting';
import ZoomIcon from '../../../common/icons/ZoomIcon';
import GoogleDriveIcon from '../../../common/icons/GoogleDriveIcon';
import TeamsIcon from '../../../common/icons/TeamsIcon';
import SharedDriveIcon from '../../../common/icons/SharedDriveIcon';
import { faChartUser } from '@fortawesome/pro-light-svg-icons';
import { connect } from 'react-redux';
import Zoom from './Zoom';
import { saveZoomMeetings } from '../actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WithRouter from '../../../Layout/Router/WithRouter';

class Body extends Component {
  state = {
    activeTab: 1,
    isLoading: false,
    currentMeetings: [],
    pastMeetings: [],
    isScheduleMeeting: false,
    isOpenClassSchedule: false,
    isOpenAdhocSchedule: false,
  };

  //Θ(1) Sets active tab
  onTabChange = (e, activeTab) => {
    this.setState({ activeTab });
  };

  toggleIsLoading = (isLoading = !this.state.isLoading) => {
    this.setState({
      isLoading,
    });
  };

  toggleIsScheduleMeeting = (isScheduleMeeting = !this.state.isScheduleMeeting) => {
    this.setState({
      isScheduleMeeting,
      isOpenClassSchedule: false,
      isOpenAdhocSchedule: false,
    });
  };

  //Θ(1) Sets Schedule class meeting panel to be opened by default
  openClassSchedule = () => {
    this.setState({
      isScheduleMeeting: true,
      isOpenClassSchedule: true,
    });
  };

  //Θ(1) Sets Schedule adhoc meeting panel to be opened by default
  openAdhocSchedule = () => {
    this.setState({
      isScheduleMeeting: true,
      isOpenAdhocSchedule: true,
    });
  };

  render() {
    const { course } = this.props;

    const isTeaching = course?.isTeaching;

    // const crn = Math.min(...course?.CRNS?.split(',').map(Number));
    // "The CRN" used for this course must use the first CRN which is the lowest CRN in the lowest term code,
    //   but not necessarily the lowest CRN overall.
    const crn = course?.CRNS?.split(',')[0];
    const termCode = course.SSBSECT_TERM_CODE;

    return (
      <React.Fragment>
        <Box
          sx={{
            width: '100%',
          }}
        >
          {!this.state.isScheduleMeeting && (
            <div>
              <Tabs
                value={this.state.activeTab}
                onChange={this.onTabChange}
                aria-label="Collaboration Tools"
                // variant="fullWidth"
                variant="scrollable"
                className="myOdu__tabs secondary cct"
              >
                <Tab
                  value={1}
                  iconPosition="start"
                  icon={
                    <Box>
                      <ZoomIcon />
                    </Box>
                  }
                  label="Zoom"
                  sx={{
                    paddingX: 2,
                    minWidth: 'fit-content',
                    flex: 1,
                  }}
                />

                {isTeaching && (
                  <Tab
                    value={5}
                    iconPosition="start"
                    icon={
                      <Box>
                        <FontAwesomeIcon icon={faChartUser} />
                      </Box>
                    }
                    label="Student Progress Notifications"
                    sx={{
                      paddingX: 2,
                      minWidth: 'fit-content',
                      flex: 1,
                    }}
                    onClick={() =>
                      this.props.isCctBald
                        ? window.open(
                            `https://${process.env.REACT_APP_DOMAIN_NAME}/studentProgress/${termCode}/${crn}`,
                            '_blank',
                          )
                        : this.props.navigate(`/studentProgress/${termCode}/${crn}`)
                    }
                  />
                )}

                <Tab
                  value={2}
                  iconPosition="start"
                  icon={
                    <Box>
                      <GoogleDriveIcon />
                    </Box>
                  }
                  label="Google Drive"
                  sx={{
                    paddingX: 2,
                    minWidth: 'fit-content',
                    flex: 1,
                  }}
                />
                <Tab
                  value={3}
                  iconPosition="start"
                  icon={
                    <Box>
                      <TeamsIcon />
                    </Box>
                  }
                  label="Teams"
                  sx={{
                    paddingX: 2,
                    minWidth: 'fit-content',
                    flex: 1,
                  }}
                />

                {isTeaching && (
                  <Tab
                    value={4}
                    iconPosition="start"
                    icon={
                      <Box>
                        <SharedDriveIcon />
                      </Box>
                    }
                    label="Shared Drive"
                    sx={{
                      paddingX: 2,
                      minWidth: 'fit-content',
                      flex: 1,
                    }}
                  />
                )}
              </Tabs>
              <Box sx={{ width: '100%', p: 3, pt: 2 }}>
                {this.state.activeTab == 1 && (
                  <Zoom
                    onTabChange={this.onTabChange}
                    toggleIsScheduleMeeting={this.toggleIsScheduleMeeting}
                    openClassSchedule={this.openClassSchedule}
                    openAdhocSchedule={this.openAdhocSchedule}
                  />
                )}
                {this.state.activeTab == 2 && <GoogleDrive />}
                {this.state.activeTab == 3 && <Teams />}
                {this.state.activeTab == 4 && <SharedDrive />}
              </Box>
            </div>
          )}
          {this.state.isScheduleMeeting && isTeaching && (
            <Box sx={{ width: '100%', p: 3, pt: 2 }}>
              <ScheduleMeeting
                toggleIsScheduleMeeting={this.toggleIsScheduleMeeting}
                onTabChange={this.onTabChange}
                isOpenClassSchedule={this.state.isOpenClassSchedule}
                isOpenAdhocSchedule={this.state.isOpenAdhocSchedule}
              />
            </Box>
          )}
        </Box>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isCCT: state.CCTReducer.isCCT,
    course: state.CCTReducer.course,
    currentMeetings: state.CCTReducer.meetings.currentMeetings,
    pastMeetings: state.CCTReducer.meetings.pastMeetings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveZoomMeetings: (meetings) => dispatch(saveZoomMeetings(meetings)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Body));
